import { createFileRoute } from "@tanstack/react-router";

import { BandLink } from "@/components/site/ctas";
import { LoopMedia } from "@/components/site/loop-media";
import { Reveal } from "@/components/site/motion";
import { getDict, href, type Lang } from "@/content/site";

export const Route = createFileRoute("/$lang/divisions/")({
  loader: ({ params }) => ({ lang: params.lang as Lang }),
  head: ({ loaderData }) => {
    const t = getDict(loaderData?.lang ?? "en");
    return { meta: [{ title: `${t.nav.divisions} · insidermark` }, { name: "description", content: t.divisionsSection.intro }] };
  },
  component: Page,
});

function Page() {
  const { lang } = Route.useLoaderData();
  const t = getDict(lang);
  return (
    <main>
      <header className="im-page-head">
        <div className="im-wrap">
          <Reveal>
            <h1 className="im-display max-w-[16ch]">{t.divisionsSection.title}</h1>
            <p className="im-body-text mt-5">{t.divisionsSection.intro}</p>
          </Reveal>
        </div>
      </header>
      <section className="im-section im-section--tight">
        <div className="im-wrap">
          <div className="im-cards" style={{ gridTemplateColumns: undefined }}>
            {t.divisions.map((d) => (
              <a className="im-card" href={href(lang, `/divisions/${d.slug}`)} key={d.slug}>
                <img fetchPriority="high" src={d.icon} alt="" width={48} height={48} />
                <span className="im-mono">DIV {d.code}</span>
                <h3>{d.name}</h3>
                <p>{d.short}</p>
                <LoopMedia className="im-acc__img" image={d.image} alt={d.name} />
              </a>
            ))}
          </div>
          <div className="mt-12">
            <BandLink to={href(lang, "/rfq")} meta={t.nav.rfq}>
              {t.closing.title}
            </BandLink>
          </div>
        </div>
      </section>
    </main>
  );
}
